// Base drawer styles
const drawerStyles = `
  .drawer {
    visibility: hidden;
    position: fixed;
    inset: 0;
    z-index: 1000;
  }
  .drawer.active {
    visibility: visible;
  }

  .drawer__overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease-in-out;
    backdrop-filter: blur(2px);
  }
  .drawer.active .drawer__overlay {
    opacity: 1;
    pointer-events: auto;
  }

  .drawer__inner,
  drawer-inner {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    max-width: 400px;
    background: rgb(var(--color-background));
    box-shadow: -2px 0 24px rgba(0, 0, 0, 0.08);
    z-index: 1001;
    height: 100vh;
    margin: 0;
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
  }
  .drawer.active .drawer__inner,
  .drawer.active drawer-inner {
    transform: translateX(0);
  }

 .drawer__close .svg-wrapper {
  height: 1.5rem;
  width: 1.5rem;
}

  .drawer__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 1.5rem 0;
    margin: 2rem 1rem;
  }
  .drawer__heading {
    font-size: 1.5rem;
    margin: 0;
    color: rgb(var(--color-foreground));
    flex: 1;
  }
  .drawer__close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: rgb(var(--color-foreground));
    padding: 0.25rem 0.5rem;
    border-radius: 9999px;
    transition: opacity 0.2s;
    margin-left: auto;
    outline: none;
    box-shadow: none;
  }
  .drawer__close:hover {
    opacity: 0.7;
  }

  .drawer__content {
    flex: 1 1 0%;
    overflow-y: auto;
    padding: 0;
  }

  @media (max-width: 768px) {
    .drawer__inner,
    drawer-inner {
      max-width: 90vw;
      width: 100vw;
    }
  }

  .drawer {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  background-color: rgba(var(--color-foreground), 0.5);
  transition: visibility var(--duration-default) ease;
}

.drawer.active {
  visibility: visible;
}

  .drawer__inner,
  drawer-inner {
    height: 100%;
    width: 45rem;
    max-width: calc(100vw - 3rem);
    padding: 0 1.5rem;
    border: 0.1rem solid rgba(var(--color-foreground), 0.2);
    border-right: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transform: translateX(100%);
    transition: transform var(--duration-default) ease;
    border-radius: var(--default-border-radius) 0 0 var(--default-border-radius);
    overflow-y: auto;
  }

.drawer__inner-empty {
  height: 100%;
  padding: 0 1.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
`;

// Inject styles if not already present
if (!document.getElementById('drawer-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'drawer-styles';
  styleSheet.textContent = drawerStyles;
  document.head.appendChild(styleSheet);
}

// Add global CSS to hide drawer-component and drawer-trigger by default
if (!document.getElementById('drawer-visibility-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'drawer-visibility-styles';
  styleSheet.textContent = `
    drawer-component, drawer-trigger { display: none !important; }
  `;
  document.head.appendChild(styleSheet);
}

class DrawerInner extends HTMLElement {}
if (!customElements.get('drawer-inner')) {
  customElements.define('drawer-inner', DrawerInner);
}

class DrawerTrigger extends HTMLElement {}
if (!customElements.get('drawer-trigger')) {
  customElements.define('drawer-trigger', DrawerTrigger);
}

class Drawer extends HTMLElement {
  constructor() {
    super();
    this.triggerBtn = null;
    this.isInitialized = false;
    // Hide until ready
    this.classList.remove('drawer-ready');
    // Move drawer to body on creation
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
        // Show only after moving to body
        this.classList.add('drawer-ready');
      }
    }
    // Initialize elements immediately for better performance
    this.initializeElements();
  }

  connectedCallback() {
    // Ensure drawer is always in body when attached to DOM
    if (this.parentNode !== document.body) {
      document.body.appendChild(this);
      // Show only after moving to body
      this.classList.add('drawer-ready');
    }
  }

  initializeElements() {
    if (this.isInitialized) return;
    
    this.overlay = this.querySelector('[id$="-Overlay"]');
    this.closeBtn = this.querySelector('[id$="-Close"]');
    // Use <drawer-inner> instead of class selector
    this.inner = this.querySelector('drawer-inner');
    
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    // Overlay click to close
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        // Only close if clicking directly on the overlay, not on its children
        if (e.target === this.overlay) {
          this.close();
        }
      });
    }
    
    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        this.close();
      });
    } else {
      // Fallback: try to find any close button
      const fallbackCloseBtn = this.querySelector('.drawer__close, [class*="close"], button[aria-label*="close"], button[aria-label*="Close"]');
      if (fallbackCloseBtn) {
        fallbackCloseBtn.addEventListener('click', this.close.bind(this));
      }
    }
    
    // Click outside drawer to close
    if (this.inner) {
      this.inner.addEventListener('click', (e) => {
        // Prevent clicks inside the drawer from closing it
        e.stopPropagation();
      });
    }
    
    // Add click listener to the drawer itself to close when clicking outside inner
    this.addEventListener('click', (e) => {
      // If click is on the drawer but not on the inner, close it
      if (e.target === this && this.inner && !this.inner.contains(e.target)) {
        this.close();
      }
    });
    
    this.isInitialized = true;
  }

  setTriggerButton(button) {
    this.triggerBtn = button;
    if (button) {
      button.setAttribute('role', 'button');
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(button);
      });
      button.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(button);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Ensure elements are initialized
    if (!this.isInitialized) {
      this.initializeElements();
    }
    
    // Prevent body scroll
    document.body.classList.add('overflow-hidden');
    
    // Trigger animation immediately for better performance
    this.classList.add('animate', 'active');

    // Use requestAnimationFrame for smooth focus trap
    requestAnimationFrame(() => {
      // Use <drawer-inner> for focus trap
      const containerToTrapFocusOn = this.querySelector('drawer-inner') || this;
      const focusElement = this.querySelector('.drawer__close') || this.querySelector('button');
      if (typeof trapFocus === 'function') {
        trapFocus(containerToTrapFocusOn, focusElement);
      }
    });

    this.focus();
  }

  close() {
    // Remove active class to trigger closing animation
    this.classList.remove('active');
    
    // Remove focus trap
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    
    // Wait for animation to complete before restoring body scroll
    this.addEventListener(
      'transitionend',
      () => {
        document.body.classList.remove('overflow-hidden');
        if (this.activeElement) this.activeElement.focus();
      },
      { once: true }
    );
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Debug method to test closing
  debugClose() {
    console.log('Debug close called');
    this.close();
  }
}

// Register the base drawer component
if (!customElements.get('drawer-component')) {
  customElements.define('drawer-component', Drawer);
}

// Utility function to initialize drawers
function initializeDrawer(drawerId, triggerId) {
  const drawerElement = document.getElementById(drawerId);
  const trigger = document.getElementById(triggerId);
  
  if (drawerElement && trigger && typeof drawerElement.setTriggerButton === 'function') {
    // Wait for drawer to be ready (moved to body)
    const checkReady = () => {
      if (drawerElement.classList.contains('drawer-ready')) {
        drawerElement.setTriggerButton(trigger);
        // Show trigger only after drawer is ready
        trigger.classList.add('drawer-ready');
      } else {
        // Check again in a moment
        setTimeout(checkReady, 10);
      }
    };
    checkReady();
  }
}

// Export for use in other files
window.Drawer = Drawer;
window.initializeDrawer = initializeDrawer; 